// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"790e0a97","845":"8698e4b1"}[chunkId] + ".chunk.js";
};